export default "__VITE_ASSET__DE$IvE_W__"